export interface SEOConfig {
  title: string;
  titleTemplate: string;
  description: string;
  canonical?: string;
  openGraph: {
    type: string;
    locale: string;
    url: string;
    siteName: string;
    title: string;
    description: string;
    images: Array<{
      url: string;
      width: number;
      height: number;
      alt: string;
    }>;
  };
  twitter: {
    handle: string;
    site: string;
    cardType: string;
  };
}

export const defaultSEOConfig: SEOConfig = {
  title: "DIY Eco Homes",
  titleTemplate: "%s | DIY Eco Homes",
  description: "Expert guidance on eco-friendly home improvements, sustainable living, and DIY projects for a greener future.",
  openGraph: {
    type: "website",
    locale: "en_US",
    url: "https://www.diyecohomes.com", // Production domain URL
    siteName: "DIY Eco Homes",
    title: "DIY Eco Homes - Sustainable Living & Home Improvement",
    description: "Expert guidance on eco-friendly home improvements, sustainable living, and DIY projects for a greener future.",
    images: [
      {
        url: "/images/og-default.jpg", // Default Open Graph image
        width: 1200,
        height: 630,
        alt: "DIY Eco Homes - Sustainable Living & Home Improvement",
      },
    ],
  },
  twitter: {
    handle: "@diyecohomes", // Twitter handle for social sharing
    site: "@diyecohomes",
    cardType: "summary_large_image",
  },
}; 